import { Card, Flex, Spin, Typography } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import SafetyAnomalyCard from './SafetyAnomalyCard';
import EmptyCard from '../../../../components/EmptyCard/EmptyCard';
import Icon from '@ant-design/icons';

const { Title } = Typography;

const SafetyAnomalyColumn = ({
  title,
  headerIcon,
  loading,
  dataList = [],
  count = 0,
  topBorderColor = 'transparent',
}) => {
  return (
    <Spin spinning={loading} size="large">
      <Card
        size="small"
        className="full-height anomaly-sos-card"
        variant="borderless"
        style={{ borderTop: `3px solid ${topBorderColor}` }}
      >
        <Flex vertical gap={10} className="full-height">
          <Flex justify="space-between" align="middle">
            <Flex gap={8} align="middle">
              {headerIcon && (
                <Icon
                  component={headerIcon}
                  style={{ fontSize: '24px', color: topBorderColor }}
                />
              )}
              <Title level={5} style={{ marginTop: 0 }}>
                {title}
              </Title>
            </Flex>
            <Title level={5} style={{ marginTop: 0 }}>
              {count}
            </Title>
          </Flex>
          {dataList?.length === 0 || !dataList ? (
            <EmptyCard />
          ) : (
            <Flex vertical gap={8} className="column-data-list">
              {dataList?.map(data => (
                <SafetyAnomalyCard
                  key={data}
                  data={data?.data}
                  titleContent={data?.titleContent}
                >
                  {data?.children}
                </SafetyAnomalyCard>
              ))}
            </Flex>
          )}
        </Flex>
      </Card>
    </Spin>
  );
};

SafetyAnomalyColumn.propTypes = {
  title: PropTypes.string.isRequired,
  headerIcon: PropTypes.elementType,
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.object,
      titleContent: PropTypes.node,
      children: PropTypes.node,
    })
  ),
  count: PropTypes.number,
  topBorderColor: PropTypes.string,
  loading: PropTypes.bool,
};

export default React.memo(SafetyAnomalyColumn);
